<template>
	<div>
		<el-upload
				:action="uploadUrl"
				:headers="{'Authorization':api_token}"
				:file-list="fileList"
				:show-file-list="false"
				accept=".pdf, .png, .jpg, .jpeg"
				:before-upload="beforeUpload"
				:on-progress="onProgress"
				:on-success="uploadedFile"
				:on-error="onError">
			<el-button
					round
					size="mini"
					type="success"
					v-text="buttonText">
			</el-button>
		</el-upload>
	</div>
</template>
<script>
	export default {
		mounted(){
			this.uploadUrl = '/api/file/save-file';
			this.api_token = 'Bearer ' + window.sessionStorage.getItem("sre_young_token");
		},
		props:{
			buttonName:{
			},
			row:{
				type: Object
			},
		},
		data() {
			return {
				fileList: [],
				uploadUrl:"",
				api_token:""
			};
		},
		computed: {
			buttonText:{
				get:function(){
					const DEFAULT_BUTTON_TEXT = "Clic para subir archivo";
					if(!this.buttonName){
						return DEFAULT_BUTTON_TEXT;
					}
					return this.buttonName
				}
			}
		},
		methods: {
			beforeUpload(file) {
				let _this = this;
				let isPDF = false;
				if (file.type === 'image/jpeg' ||
					file.type === 'image/jpg' ||
					file.type === 'image/x-png' ||
					file.type === 'image/png' ||
					file.type === 'application/pdf'
				) {
					isPDF = true;
				}

				const isLt2M = file.size / 1024 / 1024 < 5;

				if (!isPDF) {
					this.$message.error('Sólo se permiten documentos en formato PDF e imagen');
				}

				if (!isLt2M) {
					this.$message.error('Los archivos de documentos no pueden exceder los 5MB');
				}
				if(isPDF && isLt2M){
					_this.$store.dispatch('loading/spinner', { msg: 'Subiendo archivo...', status: true }, { root: true });
				}

				return isPDF && isLt2M;
			},
			uploadedFile(data){
				let _this = this;
				_this.$store.dispatch('loading/spinner', {}, { root: true });
				if(this.row!=undefined){
					data.row = this.row;
				}
				this.$emit('fileInfo', data);
			},
			onError(err, file, fileList){
				this.$Progress.fail();
				this.$store.dispatch('notifications/error', {msg: 'Ocurrió un error al intentar subir el archivo, por favor intente de nuevo.'}, {root: true});
			},
			onProgress(event, file, fileList){
				let _this = this;
				this.$Progress.set(event.percent);
				if(event.percent==100){


						this.$Progress.finish();

				}
			}
		}
	}
</script>
